import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default {
  init() {
    // JavaScript to be fired on the about us page
    gsap.registerPlugin( ScrollTrigger );

    gsap.utils.toArray('.timeline__list').forEach(section => {
    const elems = section.querySelectorAll('.js-content-opacity, li');
    // Set starting params for sections
    gsap.set(elems, {
      y: 50,
      opacity: 0,
      duration: 1,
      ease: 'power3.out',
      overwrite: 'auto',
    });

    ScrollTrigger.create({
      trigger: section,
      start: 'top 60%',
      end: 'bottom 30%',
      markers: false,
      onEnter: () => gsap.to(elems, {
        y: 0,
        opacity: 1,
        stagger: 0.2,
      }),
      onLeave: () => gsap.to(elems, {
        y: -50,
        opacity: 0,
        stagger: 0.2,
      }),
      onEnterBack: () => gsap.to(elems, {
        y: 0,
        opacity: 1,
        stagger: -0.2,
      }),
      onLeaveBack: () => gsap.to(elems, {
        y: 50,
        opacity: 0,
        stagger: -0.2,
      }),
    });
  })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHistory.js